export const BTN_TEXTS = {
  COUNT_ME_IN: "Count me in",
  CANCEL: "Cancel",
  JOIN_WAITING_ROOM: "Join Waiting Room",
  JOIN_CLASS: "Join Class",
  START_NOW: "Start Now",
}

export const ZERO_STATE_TEXT = {
  LIVE_NOW: "No live classes at the moment.",
  LIVE_UPCOMING_FOR_DAY: "No classes for this day.",
}

export const PARTICIPANT_VIDEO_VISIBILITY = {
  ALL: "ALL",
  COACH_ONLY: "COACH_ONLY",
  FRIENDS_ONLY: "FRIENDS_ONLY",
  NONE: "NONE",
}
